import { microservices } from './microservices';
const initialNavigation: any = 'disabled';
const deltaMobileProdURL = 'https://my.deltagroup.cloud';
const BaseURL = 'https://msblocks.selise.biz';
const CDN_BASE_URL = 'https://az-cdn.selise.biz/selisecdn/cdn';
const TRANSLATION_BASE_URL = 'https://api.seliseblocks.com';

export const environment = {
    production: true,
    IsAzStorage: true,
    IsStaging: true,
    addNoIndexMeta: true,
    sentryEnabled: true,
    beeUid: 'prod',
    isSSo: false,
    initialNavigation: initialNavigation,
    loadTranslationsCentrally: true,
    BlocksClientId: '4683e9bc-9071-4919-bd94-9f6eb19bb92c',
    UilmXBlocksKey:'Pd289f2fa0289414d8e096fe6da1fb29e',
    BlocksUilmService: `${TRANSLATION_BASE_URL}/uilm/v1/Key/`,
    // BlocksUilmService: `https://blocks.selise.app/api/blocks-configuration/BlocksConfiguration/UILM/`,
    Authentication: `${deltaMobileProdURL}/api/tenant/${microservices.identity.prod}/identity/Authentication/`,
    Identity: `${deltaMobileProdURL}/api/tenant/${microservices.tenant.prod}/TenantManager/TenantManagerQuery/GetIdentity`,
    Apps: `${deltaMobileProdURL}/api/appcatalogue/${microservices.appcatalogue.prod}/AppCatalogue/AppManagerQuery/GetApps`,
    Security: `${deltaMobileProdURL}/api/uam/${microservices.uam.prod}/UserAccessManagement/`,
    Token: `${deltaMobileProdURL}/api/identity/${microservices.identity.prod}/identity/token`,
    SecurityIdentity: `${deltaMobileProdURL}/api/identity/${microservices.identity.prod}/identity/`,
    Captcha: `${deltaMobileProdURL}/api/captcha/${microservices.captcha.prod}/Captcha/CaptchaCommand/`,
    DataCore: `${deltaMobileProdURL}/api/pds/${microservices.pds.prod}/AppSuiteDataCore/`,
    Storage: `${deltaMobileProdURL}/api/storageservice/${microservices.storageservice.prod}/StorageService/`,
    EmailService: `${deltaMobileProdURL}/api/mailservice/${microservices.mailservice.prod}/MailService`,
    MessaginService: `${deltaMobileProdURL}/api/messagingservice/${microservices.messagingservice.prod}/MessagingService/`,
    NotificationService: `${deltaMobileProdURL}/api/notification/${microservices.notification.prod}`,
    PdfGeneratorService: `${deltaMobileProdURL}/${microservices.pdfgenerator.prod}/PdfGeneratorService/`,
    BusinessService: `${deltaMobileProdURL}/api/business-delta/`,
    SLSNBusiness: `https://prod-selectbusiness.selise.biz/SelectNetworkBusinessService/`,
    CalendarService: `${deltaMobileProdURL}/api/calendarservice/${microservices.calendarservice.prod}/CalendarService/`,
    StaticResourceCDN: ``,
    SecureStorage: `${deltaMobileProdURL}/api/securestorage/${microservices.securestorage.prod}/StorageService/`,
    TemplateEngineService: `${deltaMobileProdURL}/api/templateengine/${microservices.templateengine.prod}/TemplateEngineService/`,
    WorkflowService: `${deltaMobileProdURL}/api/workflow/${microservices.workflow.prod}/WorkflowService/`,
    SeliSignService: `${deltaMobileProdURL}/${microservices.selisign.prod}/`,
    TwoFaService: `${deltaMobileProdURL}/api/twofa/`,
    UrlShortner: `${deltaMobileProdURL}/api/${microservices.urlShortner.prod}/`,
    CdndeltaMobileProdURL: `${CDN_BASE_URL}`,
    CdnTenantdeltaMobileProdURL: `${CDN_BASE_URL}/delta/`,
    SiteLogo: `${CDN_BASE_URL}/delta/logo-delta/delta_logo_dark.svg`,
    topBgImageUrl: `${CDN_BASE_URL}/delta/top-bg/`,
    GQLQueryUri: `${deltaMobileProdURL}/api/gqlquery/${microservices.gqlquery.prod}/graphql`,
    GQLMutationUri: `${deltaMobileProdURL}/api/gqlcommand/${microservices.gqlcommand.prod}/graphql`,

    UilmService: `${deltaMobileProdURL}/api/uilm/${microservices.uilm.prod}/languagemanager`,
    landingUri: `${deltaMobileProdURL}`,
    action: `https://`,
    CampLeadServiceUrl: `https://prod-campLead.selise.biz/CampaignLeadService/`,
    SubDomainName: `my.deltagroup.cloud`,
    DomainName: `deltagroup.cloud`,
    SessionKey: `set_from_prod-deltamobile.selise.biz`,
    Client_ID: `A54D6D82-61F6-4BD0-BAF8-BD06B0AD72FF`,
    TransportMedium: [`webSockets`],
    NotificationHubName: `NotifierServerHub`,
    PersonFields: [
        `ItemId`,
        `CreatedBy`,
        `Tags`,
        `DateOfBirth`,
        `Sex`,
        `FirstName`,
        `LastName`,
        `MiddleName`,
        `ProfileImage`,
        `Email`,
        `DisplayName`,
        `ProfileImageId`,
        `Salutation`,
        `AddressLine1`,
        `Street`,
        `PostalCode`,
        `City`,
        `Country`,
        `State`,
        `Nationality`,
        `PhoneNumber`,
        `Designation`,
        `MarriedSince`,
        `Title`,
        `PersonId`
    ],
    toBgImages: [`banner-bg/banner.png`],
    currentDateFormat: `dd MMM yyyy`,
    defaultLangKey: `en`,
    market: `AUSTRIA`,
    currency: `EUR`,
    language: [
        {
            id: `en`,
            title: `ENGLISH`,
            flag: `us`,
            value: `en-US`
        },
        {
            id: `de`,
            title: `GERMAN`,
            flag: `de`,
            value: `de-DE`
        }
    ],
    EmailValidatorRegex:
        '^([_a-z0-9A-Z-])+(\\.[_a-zA-Z0-9-]+)*@[_a-z0-9A-Z-]+(\\.[_a-zA-Z0-9-]+)*(\\.)+([a-zA-Z]{2,4})$',
    isFloatingChatPanelEnable: true,
    clientMonitoringConfig: {
        instrumentationKey: 'c4ecec5b-622c-4397-9144-35e1a90ae5a8'
    },
    CiClientRepo: 'Ecap3-Webclient-Business-Delta',
    SiteId: '42478F36-11DD-44EA-B55B-BBA21FC1320B',
    DefaultPackagePath: './assets/i18n/generic-app/',
    BuildPipelineId: 'baad454e-7566-43e7-a124-1aa290e770ad',
    campaignServiceUrl: `${deltaMobileProdURL}/api/CampaignLeadService/`,
    DocumentManagerService: `${deltaMobileProdURL}/api/dms/${microservices.documentManagerService.prod}/DmsService/`,
    InfoMailToAddContact: 'catchall@selisestaging.com',
    ConversationEmail: 'catchall@selisestaging.com',
    EnterpriseEmailPersonId: ['3251413e-7b52-49ba-a384-d468c461d804'],
    DeltaWebURL: 'https://deltagroup.cloud/',
    templateEngineService: `${deltaMobileProdURL}/api/templateengine/${microservices.templateengine.prod}/TemplateEngineService/Command/GenerateRenderedFileBulk`,
    CopyProjects: `${deltaMobileProdURL}/api/business-delta/DeltaService/Project/CopyProjects`,
    SentryClientKeyDsn: 'https://739c5c3befbf14e9ca142dbc7f85ed2b@o4507809998110720.ingest.de.sentry.io/4509915534721104',
    ReCaptchaSiteKey: '6Lf7p8YtAAAAAJEtTzlMwC_aGQqiWxu6EbCy5Z3L'
};
